"use strict";

var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.052 8.98L11 3.992H1L5.95 8.98a.073.073 0 0 0 .102 0"
  }));
};